import React from 'react';
import { FormField, FormFieldLabel, FormFieldButton } from 'styles/common.styles';

/**
 * Button ?�???�드 컴포?�트
 * 
 * 버튼???�립?�인 ?�드�??�더링합?�다.
 * 
 * @param {Object} props
 * @param {string} props.name - ?�드 ?�름 (고유 ?�별??
 * @param {string} props.label - 버튼 ?�벨 (?�택, ?�벨???�으�?버튼�??�시)
 * @param {string} props.width - ?�드 ?�비
 * @param {string} props.flex - flex ?�성
 * @param {string} props.labelWidth - ?�벨 ?�비
 * @param {string} props.fieldWidth - FormField ?�체 ?�비
 * @param {boolean} props.readonly - ?�기 ?�용 ?��? (버튼 비활?�화)
 * @param {boolean} props.hasError - ?�러 ?�태
 * @param {string} props.buttonLabel - 버튼???�시???�스??(label�?별개)
 * @param {string} props.icon - 버튼 ?�이�?(?�모지 ?�는 ?�스??
 * @param {Function} props.onClick - 버튼 ?�릭 ?�들?? * @param {string} props.variant - 버튼 ?��???('primary', 'success', 'danger' ?�는 ?�음)
 * @param {boolean} props.disabled - 버튼 비활?�화 ?��?
 * @param {Object} props.fieldProps - 추�? ?�드 ?�성
 */
const ButtonField = ({
  name,
  label,
  width,
  flex,
  labelWidth,
  fieldWidth,
  showColon = false,
  readonly = false,
  buttonLabel, // 버튼???�시???�스??(label�?별개)
  icon,
  onClick,
  variant,
  disabled = false,
  fieldProps = {},
}) => {
  // buttonLabel???�으�?label ?�용
  const displayButtonLabel = buttonLabel || label ;

  return (
    <FormField
      flex={flex || '0 0 auto'}
      width={fieldWidth || 'auto'}
    >
      {/* ?�벨???�으�??�시, ?�으�??�벨 ?�역 ?�이 버튼�?*/}
      {label && (
        <FormFieldLabel width={labelWidth}  >{showColon ? `${label}:` : label}</FormFieldLabel>
      )}
      <FormFieldButton
        type="button"
        onClick={onClick}
        disabled={disabled || readonly}
        $variant={variant}
        style={{ width: width || 'auto' }}
        {...fieldProps}
      >
        {icon && <span>{icon}</span>}
        {displayButtonLabel}
      </FormFieldButton>
    </FormField>
  );
};

export default ButtonField;

